import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-term-range',
  templateUrl: './term-range.component.html',
  standalone: false
})
export class TermRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
